import { Flex } from '@indoqa/style-system';
import * as React from 'react';
import { ColorPanel } from './ColorPanel';
import { SmallColorPanel } from './SmallColorPanel';
const renderColor = (color, small) => {
    if (small) {
        return React.createElement(SmallColorPanel, { key: color.name, color: color.hexCode });
    }
    return React.createElement(ColorPanel, { key: color.name, name: color.name, color: color.hexCode });
};
export const ColorsPanel = ({ colors, small }) => (React.createElement(Flex, null, colors.map((color) => renderColor(color, small))));
ColorsPanel.defaultProps = {
    small: false,
};
//# sourceMappingURL=ColorsPanel.js.map